"use client";
export { _ as __internal_buildRpcClient, n as normalizeApiRoute } from './chunks/rpc.mjs';
import { isClient } from 'blitz';
import { reactQueryClientReExports } from './index.mjs';
export { BlitzProvider, BlitzRpcPlugin, useInfiniteQuery, useMutation, usePaginatedQuery, useQuery } from './index.mjs';
export { emptyQueryFn, getInfiniteQueryKey, getQueryCacheFunctions, getQueryClient, getQueryData, getQueryKey, getQueryKeyFromUrlAndParams, initializeQueryClient, invalidateQuery, requestIdleCallback, sanitizeMutation, sanitizeQuery, setQueryData, validateQueryFn } from './chunks/utils.mjs';
export { QueryClient, dehydrate } from '@tanstack/query-core';
import 'next/dist/client/normalize-trailing-slash';
import 'next/dist/client/add-base-path';
import 'superjson';
import '@tanstack/react-query';
import 'react';
import 'next/compat/router';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function invoke(queryFn, params) {
  return __async(this, null, function* () {
    if (typeof queryFn === "undefined") {
      throw new Error(
        "invoke is missing the first argument - it must be a query or mutation function"
      );
    }
    if (isClient) {
      const fn = queryFn;
      return fn(params, { fromInvoke: true });
    } else {
      const fn = queryFn;
      return fn(params);
    }
  });
}
function invokeWithCtx(queryFn, params, ctx) {
  if (typeof queryFn === "undefined") {
    throw new Error(
      "invokeWithCtx is missing the first argument - it must be a query or mutation function"
    );
  }
  return queryFn(params, ctx);
}

const { QueryClientProvider, Hydrate, useQueryErrorResetBoundary } = reactQueryClientReExports;

export { Hydrate, QueryClientProvider, invoke, invokeWithCtx, useQueryErrorResetBoundary };
